<template>
    <div>
        <div>
            <span>{{name}}</span>

            <el-tooltip placement="top" v-if="data.CoursewareManagementType === 1">
                <div slot="content">仅限教务部</div>
                <i class="fa fa-user-circle color-academicAffairs" aria-hidden="true"></i>
            </el-tooltip>

            <el-tooltip placement="top" v-else-if="data.IsLocked">
                <div slot="content">仅限出勤学生或<br/>已观看视频的学生</div>
                <i class="fa fa-lock color-lock" aria-hidden="true"></i>
            </el-tooltip>
            
            <i v-else class="fa fa-unlock color-unlock" aria-hidden="true"></i>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.color-lock {
    color: #C1272D;
}

.color-unlock {
    color: #39B54A;
}

.color-academicAffairs {
    color: #006ab4;
}
</style>

<script>
export default {
    props: {
        data: {},
    },
    data() {
        return {
            name: '',
        };
    },
    components: {},
    created() {
        this.init();
    },
    methods: {
        init() {
            if (!!this.data) {
                this.name = this.data.FileName;
            }
        }
    },
    watch: {
        data: function() {
            this.init();
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/coursewareFileNameCell.vue